// http://git.pscad.co.jp:8080/gitbucket/lis/Findex.Medical.Fit/blob/develop/src/_GenericLibraries/Common/Findex.Medical.Common/Entities/Age.cs
export class Age {
  private constructor(private _year: number, private _month: number, private _days: number, private _totalDays: number) {
  }

  public get year(): number {
    return this._year;
  }

  public get month(): number {
    return this._month;
  }

  public get days(): number {
    return this._days;
  }

  public get totalDays(): number {
    return this._totalDays;
  }
  
  static calculate(birth: Date, _at?: Date): Age {
    if (birth == null) { return null; }

    const at = (_at != null) ? _at : new Date();
    return new Age(
      this.toAgeYearAt(birth, at),
      this.toAgeMonthAt(birth, at),
      this.toAgeDaysAt(birth, at),
      this.toAgeTotalDaysAt(birth, at),
    );
  }

  private static toAgeYearAt(birth: Date, at: Date): number {
    const birthDateAtYear = this.toBirthDateAtYear(birth, at.getFullYear());
    return at.getFullYear() - birth.getFullYear()
      - (at < birthDateAtYear ? 1 : 0); // 誕生日の月日を超えていなければ、1年分減らす
  }

  private static toAgeMonthAt(birth: Date, at: Date): number {
    const birthDateAtYear = this.toBirthDateAtYear(birth, at.getFullYear());
    const birthDateAtMonth = this.toBirthDateAtMonth(birth, at.getFullYear(), at.getMonth());
    return at.getMonth() - birth.getMonth()
      + ((at < birthDateAtYear) ? 12 : 0) // 誕生日の月日を超えていなければ、1年繰り下げるので12か月分加える
      - ((at < birthDateAtMonth) ? 1 : 0); // 誕生日の日を超えていなければ、1か月分減らす
  }

  private static toAgeDaysAt(birth: Date, at: Date): number {
    const birthDateAtYear = this.toBirthDateAtYear(birth, at.getFullYear());
    const birthDate = (at < birthDateAtYear)
      ? this.toBirthDateAtYear(birth, at.getFullYear() - 1) // 誕生日の月日を超えていなければ、1年分減らす
      : birthDateAtYear;
    return this.toAgeTotalDaysAt(birthDate, at);
  }

  private static toAgeTotalDaysAt(birth: Date, at: Date): number {
    const spanTime = at.getTime() - birth.getTime();
    const spanDays = Math.floor(spanTime / (1000 * 60 * 60 * 24));
    return spanDays + 1;
  }

  private static toBirthDateAtYear(birth: Date, year: number): Date {
    return new Date(
      year,
      birth.getMonth(),
      this.toDayOfMonth(year, birth.getMonth(), birth.getDate()),
      birth.getHours(),
      birth.getMinutes(),
      birth.getSeconds(),
    );
  }

  private static toBirthDateAtMonth(birth: Date, year: number, monthIndex: number): Date {
    return new Date(
      year,
      monthIndex,
      this.toDayOfMonth(year, birth.getMonth(), birth.getDate()),
      birth.getHours(),
      birth.getMinutes(),
      birth.getSeconds(),
    );
  }

  private static toDayOfMonth(year: number, monthIndex: number, day: number): number {
    // その月の最大日を超えてる場合はその月の最大日になるよう日を変更する.
    if ((year < 0) || (monthIndex < 0) || (11 < monthIndex) || (day < 1) && (31 < day)) {
      throw new Error("年(" + year + ")、月(" + monthIndex + ")、日(" + day + ")が通常取りうる範囲を超えています。");
    }
    const lastDayOfMonth = new Date(year, monthIndex + 1, 0).getDate();
    return Math.min(day, lastDayOfMonth);
  }
}
